import { Reducer } from 'redux';
import { CounterState, CounterAction } from './types';

// Type-safe initialState!
export const initialState: CounterState = {
    counters: {}
};

// Unfortunately, typing of the `action` parameter seems to be broken at the moment.
// This should be fixed in Redux 4.x, but for now, just augment your types.

const reducer: Reducer<CounterState> = (state: CounterState = initialState, action) => {
    // We'll augment the action type on the switch case to make sure we have
    // all the cases handled.
    switch (action.type) {
        case '@@counter/LOAD':
            console.log("Setting new value");
            console.log(action.payload.name, action.payload.value);
            return {
                ...state,
                counters: {
                    ...state.counters,
                    [action.payload.name]: action.payload.value
                }
            };
        case '@@counter/INCREMENT':
            let n = state.counters[action.payload.name];
            if (n === undefined) {
                n = 0;
            }
            n++;
            return {
                ...state,
                counters: {
                    ...state.counters,
                    [action.payload.name]: n
                }
            };
        default:
            return state;
    }
};

export default reducer;



// WEBPACK FOOTER //
// ./store/counter/reducer.ts